// extracted by mini-css-extract-plugin
module.exports = {"btn":"DarkYellowFilledBtn_btn__qZK4S"};